const locale = {
	// #region Requests fields
	DETAILS_REQUESTS_FIELD_TITLE: 'Titolo',
	DETAILS_REQUESTS_FIELD_WARNING: 'Warning',
	DETAILS_REQUESTS_FIELD_BLOCKED: 'Bloccato',
	DETAILS_REQUESTS_FIELD_STATUS: 'Stato Segnalazione',
	DETAILS_REQUESTS_FIELD_TYPE: 'Tipo Segnalazione',
	DETAILS_REQUESTS_FIELD_SIGNALLER_USER: 'Utente segnalatore',
	DETAILS_REQUESTS_FIELD_ASSIGNED_USER: 'Utente assegnato',
	DETAILS_REQUESTS_FIELD_DATE_FROM: 'Data presa in carico',
	DETAILS_REQUESTS_FIELD_DATE_TO: 'Data chiusura',
	DETAILS_REQUESTS_FIELD_DATE_CREATED: 'Data creazione',
	DETAILS_REQUESTS_FIELD_USER_CLOSED: 'Chiuso da',
	DETAILS_REQUESTS_FIELD_CLOSED_REASON: 'Motivo chiusura',
	DETAILS_REQUESTS_FIELD_TAGS: 'Tag',
	// #endregion

	DETAILS_HEADER_BUTTON_REQUESTS_DOCUMENTS_SETTINGS: 'Configurazione documenti'
};

export default locale;
